import { render, staticRenderFns } from "./AddV2.vue?vue&type=template&id=5de9dfe8&scoped=true"
import script from "./AddV2.vue?vue&type=script&lang=js"
export * from "./AddV2.vue?vue&type=script&lang=js"
import style0 from "./AddV2.vue?vue&type=style&index=0&id=5de9dfe8&prod&lang=css"
import style1 from "./AddV2.vue?vue&type=style&index=1&id=5de9dfe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de9dfe8",
  null
  
)

export default component.exports